import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed, toObservable, toSignal } from '@angular/core/rxjs-interop';
import { ValidationErrorKey } from '@checkout-v2/const';
import { CheckoutValidationService } from '@checkout-v2/feature';
import { SystemMessageComponent } from '@sdvor/shared/ui/v2';
import { ScrollToService } from '@shared/v2';
import { map, switchMap } from 'rxjs';

@Component({
  selector: 'sd-checkout-validation-error',
  imports: [SystemMessageComponent],
  templateUrl: './checkout-validation-error.component.html',
  styleUrls: ['./checkout-validation-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutValidationErrorComponent implements OnInit {
  errorKeys = input.required<ValidationErrorKey[]>();

  private readonly checkoutValidationService = inject(CheckoutValidationService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly scrollToService = inject(ScrollToService);
  private readonly elementRef = inject(ElementRef);

  protected readonly error = toSignal(
    toObservable(this.errorKeys).pipe(
      switchMap((errorKeys) => this.checkoutValidationService.getErrorsEvent(...errorKeys)),
      map((errors) => (errors ? Object.values(errors)[0] : undefined)),
    ),
  );

  ngOnInit(): void {
    this.checkoutValidationService
      .getScrollToEvent(...this.errorKeys())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        setTimeout(() => {
          this.scrollToService.scrollToElement(this.elementRef.nativeElement, {
            offset: -100,
          });
        }, 0);
      });
  }
}
